import PageMain from '../../components/Navigation/PageMain/PageMain';
import ClientFields from '../../components/Settings/ClientFields/ClientFields';
import { useClientFields } from '../../sic-lib/api/hooks/useClientFields';

export default function CustomFieldsPage() {
    /*
        TIP: request for page dependancies which should be resolved before 
        displaying page children
     */

    const { isLoading, isError } = useClientFields();

    return (
        <PageMain pageTitle="Custom Fields" showError={isError} showLoading={isLoading}>
            <div className="settingsPage">
                <div className="settingsPage__wrapper">
                    <ClientFields />
                </div>
            </div>
        </PageMain>
    );
}
